module.exports = __webpack_public_path__ + "static/media/porject2.c92bc2c2.png";